import cross from '~/assets/icons/cross.svg';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '../Button';

const CloseButton = ({
	height,
	color = ButtonColors.Black1,
	onClick,
	iconSize = 16,
	borderRadius = ButtonBorderRadius.Radius10,
}: {
	height: ButtonHeight;
	color?: ButtonColors;
	borderRadius?: ButtonBorderRadius;
	iconSize?: number;
	onClick: () => void;
}) => {
	return (
		<Button
			aria-label="Закрыть"
			height={height}
			onClick={onClick}
			color={color}
			square
			borderRadius={borderRadius}
		>
			<img src={cross} width={iconSize} height={iconSize} />
		</Button>
	);
};

export { CloseButton };
